import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../../../shared/types/api.types'
import { getDiscountCodesForAdminApi } from './getDiscountCodesForAdmin.api'
import getDiscountCodesForAdminInitialState from './getDiscountCodesForAdmin.initialState'
import {
  GetDiscountCodesForAdminErrorResponse,
  GetDiscountCodesForAdminRequestPayload
} from './getDiscountCodesForAdmin.types'

export const getDiscountCodesForAdmin = createAsyncThunk(
  urls.admin.getDiscountCodesForAdmin,
  async (payload: GetDiscountCodesForAdminRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await getDiscountCodesForAdminApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const getDiscountCodesForAdminSlice = createSlice({
  name: urls.admin.getDiscountCodesForAdmin,
  initialState: getDiscountCodesForAdminInitialState,
  reducers: {
    resetGetDiscountCodesForAdmin: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDiscountCodesForAdmin.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getDiscountCodesForAdmin.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getDiscountCodesForAdmin.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetDiscountCodesForAdminErrorResponse
        state.success = null
      })
  }
})

export const { actions: getDiscountCodesForAdminActions, reducer: getDiscountCodesForAdminReducer } =
  getDiscountCodesForAdminSlice
export const { resetGetDiscountCodesForAdmin } = getDiscountCodesForAdminActions
export default getDiscountCodesForAdminSlice.reducer
